"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = propsEvalOrReturn;

function propsEvalOrReturn(value, props) {
  var result = value;

  while (typeof result === 'function') {
    // $FlowFixMe this is correct for our use case
    result = result(props);
  } // This catches the edge case where result is the result of a css`` call.


  return result ? result.styles || result : result;
}